const CLEAN_UP_CONTAINERS = ['google-tag-manager', 'google-tag-manager-platform'];

export const unifyAnalytics = (analytics) => {
  const next = { ...analytics };

  if (next['google-floodlight']) {
    next['google-floodlight'].id = next['google-floodlight'].floodlight_id;
  }

  if (next['google-conversion']) {
    const conversion = next['google-conversion'];

    next['google-conversion'].id = `${conversion.id}/${conversion.label}`;
  }

  if (next['twitter']) {
    next['twitter'].id = next['twitter'].universal_id;
  }

  if (next['snapchat']) {
    next['snapchat'].id = next['snapchat'].snapchat_pixel_id;
  }

  if (next['adroll']) {
    const adroll = next['adroll'];

    next['adroll'].id = `${adroll.adv_id}/${adroll.pix_id}`;
  }

  // set measurement_ids to undefined since there is no need to
  // instantiate it many times but just once
  if(!next['el_custom_pixel_page_view']?.measurement_ids?.length) {
    delete next['el_custom_pixel_page_view'];
  }

  if (next['el_custom_pixel_add_to_cart']?.measurement_ids?.length) {
    next['el_custom_pixel_add_to_cart'] = {
      measurement_ids: undefined,
      id: 'add_to_cart'
    }
  } else {
    delete next['el_custom_pixel_add_to_cart'];
  }

  if (next['el_custom_pixel_purchase']?.measurement_ids?.length) {
    next['el_custom_pixel_purchase'] = {
      measurement_ids: undefined,
      id: 'purchase'
    }
  } else {
    delete next['el_custom_pixel_purchase'];
  }

  if (next['custom-gtm']) {
    next['custom-gtm'] = {
      id: 'custom-gtm',
    };
  }

  if (next['ecommerce-manager']) {
    next['ecommerce-manager'] = {
      id: 'ecommerce-manager',
    };
  }

  if (next['thetradedesk']) {
    const thetradedesk = next['thetradedesk'];

    next['thetradedesk'].id = `${thetradedesk.advertiser_id}`;
    next['thetradedesk'].args = thetradedesk.pixel_ids;
  }

  CLEAN_UP_CONTAINERS.forEach(container => {
    if (next[container]) {
      delete next[container];
    }
  });

  return next;
};
